(ns frontend.view.nev.kyc.process-status-views.approved-modified-status
  (:require [frontend.view.nev.kyc.process-status-views.edit-view :as edit-view]
            [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]
            [frontend.view.entity-viewers.modules.attachments :as attachments]
            [frontend.state.current-session :as session]
            [ui.components.button.view :as button]
            [common.localization :as loc]))

(defn view [state-atom entity save! approved-modified-edit-mode?* field-errors-atom]
  [edit-view/view {:state-atom      state-atom
                   :save!           save!
                   :entity          entity
                   :mandatory?      false
                   :read-only?      (not @approved-modified-edit-mode?*)
                   :lang            :en
                   :field-errors-atom field-errors-atom
                   :footer-renderer (fn [_state-atom _answers-atom entity]
                                      (let [entity-id (:db/id entity)
                                            attachments (->> entity
                                                             :common/attachments
                                                             (filter (fn [attachment-id]
                                                                       (= attachment-id (:kyc-process/signed-document entity))))
                                                             (map session/get-entity))]
                                        [:div.d-flex.flex-static.flex-column.kyc-submit-footer
                                         [:div
                                          {:class-name "container"}
                                          [:div
                                           {:class-name "grid grid-cols-10 gap-4 px-4"}
                                           [:div
                                            {:class-name "col-span-10"}
                                            [:div.attachment-list.px-0.pb-3
                                             (doall
                                              (for [attachment attachments]
                                                ^{:key (str "attachment-" entity-id "-" (or (:db/id attachment)
                                                                                            attachment))}
                                                [attachments/attachment-view {:attachment   attachment
                                                                              :hide-delete? true
                                                                              :target-id    entity-id}]))]]
                                           [:div
                                            {:class-name "col-span-4"}
                                            [kvu/exit-button entity :en]]
                                           [:div
                                            {:class-name "col-span-6"}
                                            [:div.d-flex.justify-content-end
                                             [button/secondary-hollow
                                              {:on-click #(swap! approved-modified-edit-mode?* not)}
                                              (if @approved-modified-edit-mode?*
                                                [:<>
                                                 [:i {:class "fal fa-lock"}]
                                                 (loc/tr :exit-edit-mode)]
                                                [:<>
                                                 [:i {:class "fal fa-pencil"}]
                                                 (loc/tr :enter-edit-mode)])]]]]]]))}])

